import * as React from "react";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { AdminStatistics } from "../models";

import { AdminStatisticsGridNew } from "./AdminStatisticsGridNew";
import { AdminStatisticsGridOld } from "./AdminStatisticsGridOld";

interface Props {
    statistics: AdminStatistics;
}

export const AdminStatisticsGrid = (props: Props) => {
    const isMuiMigrationEnabled = getFeatureToggles()[FeatureToggleNames.EnableMuiMigration];
    if (isMuiMigrationEnabled) {
        return <AdminStatisticsGridNew {...props} />;
    }

    return <AdminStatisticsGridOld {...props} />;
};
